// Mein Konto (/rechnung/konto); Inhalt in seiten/Konto.tsx (erst bei Bedarf geladen)
import { faul } from './faul';

export const KontoSeite = faul(() => import('./seiten/Konto'));
